if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
                const productCards = recommendations.querySelectorAll('a[href*="/products/"]');
                
                if (productCards.length) {
                    const relatedProducts = [];
                    
                    productCards.forEach((link) => {
                        const name = link.getAttribute('aria-label')?.trim();
                        const urlObj = new URL(link.href, window.location.origin);
                        const cleanUrl = urlObj.origin + urlObj.pathname;
                        
                        if (name && !relatedProducts.find(p => p.url === cleanUrl)) {
                            relatedProducts.push({
                                "@type": "Product",
                                name: name,
                                url: cleanUrl
                            });
                        }
                    });
                    
                    if (relatedProducts.length) {
                        const ldScript = document.getElementById('product-ld-json');
                        if (ldScript) {
                            try {
                                const data = JSON.parse(ldScript.textContent);
                                data.isRelatedTo = relatedProducts;
                                ldScript.textContent = JSON.stringify(data, null, 2);
                            } catch (e) {
                                console.warn('Error parsing JSON-LD:', e);
                            }
                        }
                    }
                }
                
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
